import Header from "@/components/Header"

const VestingManagementPage: React.FC = () => {
    return <>
        <Header />
        <div className="max-w-5xl mx-auto px-5 pb-8">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-3xl font-bold">Vesting Management</h1>
            </div>
        </div>
    </>
}

export default VestingManagementPage